import {AssetUploadProperty} from "../upload/upload.model";
import {AssetProperties, AssetWithProperties} from "./asset.model";

export function buildAssetProperties(properties: AssetUploadProperty[], a: AssetWithProperties): AssetProperties {
    let assetProps: AssetProperties = {};
    for (let property of properties) {
        if (Object.hasOwn(a, property.name)) {
            // @ts-ignore this has to be the correct type
            assetProps[property.name] = a[property.name];
        }
    }
    return assetProps;
}